import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ImagesGalleryRowComponent from "./images-gallery-row/images-gallery-row-component";
class ImagesGalleryComponent extends PureComponent {
    convertToMatrixIfNeeded(assets) {
        if (assets && !Array.isArray(assets[0])) {
            return [
                assets
            ];
        }
        return assets;
    }
    render() {
        let { assets, shadow, screenRatios, grayscale, shouldTrackMouseEvents } = this.props;
        assets = this.convertToMatrixIfNeeded(assets);
        return /*#__PURE__*/ _jsx("div", {
            className: "images-gallery",
            children: assets.map((assetsRow, index)=>/*#__PURE__*/ _jsx(ImagesGalleryRowComponent, {
                    grayscale: grayscale,
                    assets: assetsRow,
                    shadow: shadow,
                    screenRatios: screenRatios,
                    shouldTrackMouseEvents: shouldTrackMouseEvents
                }, index))
        });
    }
}
export { ImagesGalleryComponent as default };
ImagesGalleryComponent.defaultProps = {
    assets: [],
    grayscale: false
};
